<div class="liveco-topbar w-full !py-0 border-b-[1px] border-tw-lightgrey flex h-[5rem] justify-between"
  [style.--brand-topbar-bg]="topbarBackgroundColor"
  [style.--brand-topbar-text]="topbarTextColor"
  [class.has-brand-theme]="topbarBackgroundColor"
  #containerHeader>
  <div class="flex gap-12 justify-start items-center h-full">
    @if (showDiademLogo) {
      <a (click)="removeFilterDashboard()" [routerLink]="'/'"><img class="topbar-logo-card w-36 max-w-36 max-h-[5rem]" src="assets/svg/LogoDiadem.svg" alt="logo-diadem"></a>
    }
    @if (showTeamCreatifLogo) {
      <img class="w-36 max-w-36 max-h-[5rem] bg-tw-primary rounded-lg px-2 py-1" src="assets/svg/LogoTC.svg" alt="logo-team">
    }
    @if (isClient) {
      @for (logo of urlLogoClient; track logo) {
        @if (!failedLogoUrls.has(logo)) {
          <mat-divider vertical class="h-[3rem]" />
          <img class="topbar-logo-card w-full max-h-[3rem]" [class.without-logo-padding]="!showBrandLogoPadding" [src]="logo" (error)="onLogoError(logo)">
        }
      }
    }
  </div>
  <app-nav [userFullName]="userFullName" [userEasydiadem]="userEasydiadem" class="flex h-full" />
</div>
@if (easyDiademRoute()) {
  <div class="easydiadem-header sticky top-0 z-[60] h-[4rem]" [ngClass]="isClient ? 'blue' : 'red'">
    <a [routerLink]="'/easydiadem/dashboard'">
      <div class="flex gap-2 justify-start items-center h-full container" #easydiademHeader>
        <mat-icon [svgIcon]="'ed-hand'" class="!w-[2rem] !h-[2rem] text-white" />
        <h2 class="m-0 text-white !text-[1.75rem] font-bold">Easy Diadem</h2>
      </div>
    </a>
  </div>
}
